export const productManagementContainerStyle = () => ({
  background: "#D4D4D4",
  height: "100%",
  textAlign: "center",
  "> p": {
    typography: "h1",
    fontWeight: "bold",
    paddingTop: "32px",
  },
});
